var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-time"},[_c('strong',{staticClass:"date"},[_vm._v(_vm._s(_vm.formatDate(_vm.time)))]),_vm._v(" ·\n\t"),_c('span',{staticClass:"time"},[_vm._v(_vm._s(_vm.formatTime(_vm.time)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }